"use client";

import React, { useEffect, useState } from "react";
import { House, Recycle, MapPin, Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  value: 15,
  suffix: "\n",
  label: "Années d'Expertise / Years of Expertise",
  icon: Star
}, {
  id: 4,
  value: 50,
  suffix: "\n",
  label: "PAYS CONNECTES",
  icon: House
}];
function StatCard({
  stat,
  index
}: {
  stat: typeof stats[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.5
  });
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const end = stat.value;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, stat.value]);
  const Icon = stat.icon;
  return <div data-section-id="225004" data-index={index} ref={ref} className="group relative flex flex-col items-center justify-center overflow-hidden rounded-lg border border-border bg-card p-8 text-center shadow-sm transition-all hover:shadow-md">
      <div className="absolute inset-0 translate-y-full bg-primary/10 transition-transform duration-500 ease-in-out group-hover:translate-y-0" />
      
      <div className="relative z-10 mb-6 rounded-none border border-border bg-muted p-4">
        <Icon className="size-8 text-primary" strokeWidth={1.5} />
      </div>
      
      <div className="relative z-10 mb-2 flex items-center font-default text-4xl font-bold text-primary md:text-5xl">
        {count.toLocaleString()}
        <span className="text-primary">{stat.suffix}</span>
      </div>
      
      <div className="relative z-10 font-sans text-xs font-semibold uppercase tracking-widest text-foreground md:text-sm">
        {stat.label}
      </div>
    </div>;
}
export default function ByTheNumbers() {
  return <section id="lexpertise-f2s-en-chiffres-f2s-by-the-numbers" className="dark bg-background">
      <div className="border-y border-border bg-background py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="mx-auto mb-16 max-w-3xl text-center">
            <h2 className="mb-4 font-default text-3xl font-bold uppercase tracking-tight text-foreground md:text-5xl">
              L'Expertise F2S en <span className="text-primary">Chiffres</span>
            </h2>
            <p className="font-sans text-muted-foreground">
              Une présence stratégique au Sénégal et à l'international pour des solutions logistiques d'excellence.
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, i) => <StatCard key={stat.id} stat={stat} index={i} />)}
          </div>
        </div>
      </div>
    </section>;
}